import { render, staticRenderFns } from "./RoleMembers.vue?vue&type=template&id=8b3a44f0&scoped=true"
import script from "./RoleMembers.vue?vue&type=script&lang=ts"
export * from "./RoleMembers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3a44f0",
  null
  
)

export default component.exports